import React from 'react';
import { Result } from 'antd';
import OverlayMessage, {
  OverlayMessageIcon,
} from '../../../../../../../components/global/ContentOverlay/OverlayComponents';

const SkuRedistributionRunningMessage: React.FC = () => {
  return (
    <Result
      data-type="skuRedistributionPending"
      status="info"
      title="SKU Redistribution import is running"
      subTitle="Please wait, the import will finish in a few moments"
      icon={<OverlayMessage title="Running" icon={OverlayMessageIcon.SPINNER} />}
    />
  );
};

export default SkuRedistributionRunningMessage;
